import { render, staticRenderFns } from "./WidgetContactInfo.vue?vue&type=template&id=6425719c&scoped=true&"
import script from "./WidgetContactInfo.vue?vue&type=script&lang=js&"
export * from "./WidgetContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./WidgetContactInfo.vue?vue&type=style&index=0&id=6425719c&lang=scss&scoped=true&"
import style1 from "./WidgetContactInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6425719c",
  null
  
)

export default component.exports